// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.preview-header {
   background: #2ab4c0;
   height: 60px;
   padding: 0 15px 0 10px;
}

.tab-info {
   height: 100%;
   margin-left: -12px;
   width: 318px;
}

.preview-header .back-button {
   background: transparent;
   border: none;
   color: rgba(255, 255, 255, .7);
   cursor: pointer;
   outline: none;
   width: 32px;
   height: 32px;
}

.doc-title {
   margin: 0 15px 0 5px;
}

.doc-title h1 {
   color: #fff;
   font-size: 16px;
   font-weight: normal;
   margin: 0;
   padding: 0;
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
}

.doc-title-modified {
   color: rgba(255, 255, 255, .7);
   font-size: 12px;
   margin-top: 3px;
}

.file-action {
   justify-content: flex-end;
}

.file-action button + button {
   margin-left: 1em;
}

.file-action button.mat-button, .file-action button.mat-raised-button {
   line-height: 28px;
   min-width: 80px;
   padding: 0 12px;
}


.image-viewer {
   overflow: auto;
}

.image-viewer img {
   background: #fff;
   max-width: 100%;
}

.image-viewer::ng-deep svg {
   width: 100%;
}

.text-viewer {
   overflow: auto;
   padding: 1em;
   white-space: pre-wrap;
}

.mail-viewer {
   padding: 1em;
}

.mail-viewer table, .mail-viewer iframe, iframe {
   border-collapse: collapse;
   border: none;
   width: 100%;
   height: 100%;
}

.mail-viewer td:first-child {
   padding: 3px 5px;
   text-align: right;
   width: 80px;
}

.mail-viewer td:last-child {
   padding: 3px 5px;
}

.address::ng-deep b {
   color: #222;
   font-weight: normal;
}

.mail-viewer .body {
   height: 100%;
   width: 100%;
   vertical-align: top;
}

.mail-viewer td.attachment {
   padding: 3px;
}

.mail-viewer .attachment div {
   display: inline-block;
   margin-right: 1em;
   line-height: 2;
}

.mail-viewer a {
   color: #ba68c8;
   cursor: pointer;
}

.mail-viewer td:first-child {
   color: #222;
}

.mail-viewer td.text {
   padding: 0;
}

.mail-viewer td.html {
   padding: 10px 0 0;
}

.mail-viewer .subject, .mail-viewer .fit {
   background: #fff;
   border: 1px solid #ececec;
   border-radius: 3px;
   box-shadow: inset 0 0 6px rgba(0, 0, 0, .05);
   padding: 3px 5px;
   white-space: pre-wrap;
}

.body iframe {
   border: 1px solid #f4f5f7;
   border-radius: 3px;
}

.mail-viewer .fit {
   height: 100%;
   overflow: auto;
   padding: .5em 1em;
}

audio {
   min-width: 80%;
   visibility: hidden;
}

.video-viewer {
   background-color: black;
}

video {
   max-width: 100%;
   max-height: 100%;
   visibility: hidden;
}

.visible {
   visibility: visible;
}

.can-not-preview {
   padding: 2em;
   text-align: center;
}

.preview-icon {
   opacity: .7;
   width: 160px;
   height: 160px;
   margin: auto;
}

.preview-error {
   color: #1b2733;
   font-size: 18px;
   margin: 8px;
}

.preview-error-info {
   color: #637282;
}

.preview-error-info span {
   margin: 0 8px;
}

.can-not-preview button {
   margin: 8px;
}


.info {
   background: #fff;
   width: 320px;
   min-width: 320px;
   overflow-y: auto;
   transition: margin-right .2s;
}

.section-header {
   border-bottom: 1px solid #eaeaea;
   color: #222;
   padding-bottom: 10px;
   margin: 30px 0 10px;
}

.info .properties {
   font-size: 13px;
   line-height: 16px;
   margin: 0;
   padding: 0;
}

.info .edit {
   color: #2ab4c0;
   cursor: pointer;
   font-size: 13px;
   font-weight: 300;
}

.info label,
.info dl dt {
   color: #777;
   display: block;
   margin: 20px 0 0;
   padding-bottom: 3px;
}

.info dl dd {
   color: #444;
   margin: 0 0 20px;
   word-break: break-all;
}

.info input,
.info textarea {
   border: 1px solid #e5e5e5;
   border-radius: 2px;
   font-size: 13px;
   outline: none;
   padding: 3px 6px;
   resize: none;
   width: 100%;
}

.select-types {
   padding-bottom: 10px;
   margin: 30px 0 10px;
   width: 100%;
}

.save-metadata {
   margin-top: 20px;
   text-align: right;
}

.save-button {
   line-height: 1.7;
   min-width: inherit;
   padding: 0 1em;
}


mat-tab-group {
   width: 100%;
}

.info::ng-deep .mat-tab-label {
   height: auto;
   line-height: 36px;
   min-width: inherit;
   padding: 0 1em;
}

.info::ng-deep .mat-tab-body-wrapper {
   flex: 1;
   margin-left: -5px;
}

.info::ng-deep .mat-tab-body-content {
   display: flex;
   flex-direction: column;
   padding: 0 1em;
   margin-right: -15px;
   margin-left: 5px;
}

.example-header-image {
   background-image: url('profile.png');
   background-size: cover;
}

.commentItem:hover .delComment {
   display: block;
}

.delComment {
   display: none;
}

.comments-container {
   overflow-y: auto;
}

.no-comment {
   padding: 1em;
}

.comments-container ul {
   list-style: none;
   margin: 0;
   padding: 0;
}

.comments-container li {
   margin-top: 1em;
}

.comment-item {
   line-height: 20px;
   margin-left: 48px;
   position: relative;
}

.comment-item a {
   cursor: pointer;
}

.btn-comment {
   position: absolute;
   top: 0;
   right: 0;
}

.comment-item .avatar {
   float: left;
   margin-left: -48px;
   margin-top: 3px;
   width: 36px;
   height: 36px;
   border-radius: 50%;
}

.comment-item .time {
   color: #657786;
   font-size: 12px;
}

.comment-item .time:before {
   content: "\\00b7";
   padding: 0 5px;
}

.comment-item .delete {
   color: #999;
   cursor: pointer;
   position: absolute;
   top: 0;
   right: 0;
   font-size: 20px;
   width: 20px;
   height: 20px;
   display: none;
}

.comment-item:hover .delete {
   display: block;
}

.comment-item .delete:hover {
   color: #d32f2f;
}

.add-comment {
   text-align: right;
   margin-bottom: 10px;
}

.add-comment textarea {
   display: block;
}

.add-comment button {
   margin-top: .5em;
   padding: 1px 16px;
   line-height: initial;
   min-width: 64px;
}

.relative {
   position: relative;
}

.page-notfound {
   text-align: center;
   padding: 10em;
}

.page-notfound-error {
   color: #1b2733;
   font-size: 30px;
   margin: 8px;
}

.page-notfound-icon {
   opacity: .7;
   width: 200px;
   height: 200px;
   margin: auto;
}

.img-center {
   display: flex; /*for IE*/
   display: -webkit-box;
   align-items: center;
   justify-content: center;
}

.slide-right {
   margin-right: -320px;
}

.slide-left {
   margin-left: -100px;
}

.blur {
   filter: blur(4px);
}

.editing .item-content, .textarea-content {
   display: none;
}

.editing .textarea-content {
   display: block;
}

.textarea-content {
   margin-top: 5px;
}

.edit2, .delete2 {
   color: #999;
   vertical-align: middle;
   font-size: 16px;
   text-align: center;
   display: none;
   cursor: pointer;
}

.edit2:hover, .delete2:hover {
   color: #d32f2f;
}

.comment-item:hover .delete2, .comment-item:hover .edit2 {
   display: table-cell;
}

.word-break {
   word-break: break-all;
   white-space: pre-line;
}

::ng-deep .mat-tab-body {
   top: 0;
   left: 0;
   right: 0;
   bottom: 0;
   position: absolute;
   display: block;
   overflow: hidden;
   flex-basis: 100%;
}

.set-scroll-hide {
   overflow-y: hidden;
}

.set-scroll {
   overflow-y: scroll;
}
`, "",{"version":3,"sources":["webpack://./src/app/e-signature/sign-document/sign-dialog/sign-dialog.component.css"],"names":[],"mappings":"AAAA;GACG,mBAAmB;GACnB,YAAY;GACZ,sBAAsB;AACzB;;AAEA;GACG,YAAY;GACZ,kBAAkB;GAClB,YAAY;AACf;;AAEA;GACG,uBAAuB;GACvB,YAAY;GACZ,8BAA8B;GAC9B,eAAe;GACf,aAAa;GACb,WAAW;GACX,YAAY;AACf;;AAEA;GACG,oBAAoB;AACvB;;AAEA;GACG,WAAW;GACX,eAAe;GACf,mBAAmB;GACnB,SAAS;GACT,UAAU;GACV,mBAAmB;GACnB,gBAAgB;GAChB,uBAAuB;AAC1B;;AAEA;GACG,8BAA8B;GAC9B,eAAe;GACf,eAAe;AAClB;;AAEA;GACG,yBAAyB;AAC5B;;AAEA;GACG,gBAAgB;AACnB;;AAEA;GACG,iBAAiB;GACjB,eAAe;GACf,eAAe;AAClB;;;AAGA;GACG,cAAc;AACjB;;AAEA;GACG,gBAAgB;GAChB,eAAe;AAClB;;AAEA;GACG,WAAW;AACd;;AAEA;GACG,cAAc;GACd,YAAY;GACZ,qBAAqB;AACxB;;AAEA;GACG,YAAY;AACf;;AAEA;GACG,yBAAyB;GACzB,YAAY;GACZ,WAAW;GACX,YAAY;AACf;;AAEA;GACG,gBAAgB;GAChB,iBAAiB;GACjB,WAAW;AACd;;AAEA;GACG,gBAAgB;AACnB;;AAEA;GACG,WAAW;GACX,mBAAmB;AACtB;;AAEA;GACG,YAAY;GACZ,WAAW;GACX,mBAAmB;AACtB;;AAEA;GACG,YAAY;AACf;;AAEA;GACG,qBAAqB;GACrB,iBAAiB;GACjB,cAAc;AACjB;;AAEA;GACG,cAAc;GACd,eAAe;AAClB;;AAEA;GACG,WAAW;AACd;;AAEA;GACG,UAAU;AACb;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,gBAAgB;GAChB,yBAAyB;GACzB,kBAAkB;GAClB,4CAA4C;GAC5C,gBAAgB;GAChB,qBAAqB;AACxB;;AAEA;GACG,yBAAyB;GACzB,kBAAkB;AACrB;;AAEA;GACG,YAAY;GACZ,cAAc;GACd,iBAAiB;AACpB;;AAEA;GACG,cAAc;GACd,kBAAkB;AACrB;;AAEA;GACG,uBAAuB;AAC1B;;AAEA;GACG,eAAe;GACf,gBAAgB;GAChB,kBAAkB;AACrB;;AAEA;GACG,mBAAmB;AACtB;;AAEA;GACG,YAAY;GACZ,kBAAkB;AACrB;;AAEA;GACG,WAAW;GACX,YAAY;GACZ,aAAa;GACb,YAAY;AACf;;AAEA;GACG,cAAc;GACd,eAAe;GACf,WAAW;AACd;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,aAAa;AAChB;;AAEA;GACG,WAAW;AACd;;;AAGA;GACG,gBAAgB;GAChB,YAAY;GACZ,gBAAgB;GAChB,gBAAgB;GAChB,4BAA4B;AAC/B;;AAEA;GACG,gCAAgC;GAChC,WAAW;GACX,oBAAoB;GACpB,mBAAmB;AACtB;;AAEA;GACG,eAAe;GACf,iBAAiB;GACjB,SAAS;GACT,UAAU;AACb;;AAEA;GACG,cAAc;GACd,eAAe;GACf,eAAe;GACf,gBAAgB;AACnB;;AAEA;;GAEG,WAAW;GACX,cAAc;GACd,gBAAgB;GAChB,mBAAmB;AACtB;;AAEA;GACG,WAAW;GACX,gBAAgB;GAChB,qBAAqB;AACxB;;AAEA;;GAEG,yBAAyB;GACzB,kBAAkB;GAClB,eAAe;GACf,aAAa;GACb,gBAAgB;GAChB,YAAY;GACZ,WAAW;AACd;;AAEA;GACG,oBAAoB;GACpB,mBAAmB;GACnB,WAAW;AACd;;AAEA;GACG,gBAAgB;GAChB,iBAAiB;AACpB;;AAEA;GACG,gBAAgB;GAChB,kBAAkB;GAClB,cAAc;AACjB;;;AAGA;GACG,WAAW;AACd;;AAEA;GACG,YAAY;GACZ,iBAAiB;GACjB,kBAAkB;GAClB,cAAc;AACjB;;AAEA;GACG,OAAO;GACP,iBAAiB;AACpB;;AAEA;GACG,aAAa;GACb,sBAAsB;GACtB,cAAc;GACd,mBAAmB;GACnB,gBAAgB;AACnB;;AAEA;GACG,oCAA8D;GAC9D,sBAAsB;AACzB;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,aAAa;AAChB;;AAEA;GACG,gBAAgB;AACnB;;AAEA;GACG,YAAY;AACf;;AAEA;GACG,gBAAgB;GAChB,SAAS;GACT,UAAU;AACb;;AAEA;GACG,eAAe;AAClB;;AAEA;GACG,iBAAiB;GACjB,iBAAiB;GACjB,kBAAkB;AACrB;;AAEA;GACG,eAAe;AAClB;;AAEA;GACG,kBAAkB;GAClB,MAAM;GACN,QAAQ;AACX;;AAEA;GACG,WAAW;GACX,kBAAkB;GAClB,eAAe;GACf,WAAW;GACX,YAAY;GACZ,kBAAkB;AACrB;;AAEA;GACG,cAAc;GACd,eAAe;AAClB;;AAEA;GACG,gBAAgB;GAChB,cAAc;AACjB;;AAEA;GACG,WAAW;GACX,eAAe;GACf,kBAAkB;GAClB,MAAM;GACN,QAAQ;GACR,eAAe;GACf,WAAW;GACX,YAAY;GACZ,aAAa;AAChB;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,iBAAiB;GACjB,mBAAmB;AACtB;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,gBAAgB;GAChB,iBAAiB;GACjB,oBAAoB;GACpB,eAAe;AAClB;;AAEA;GACG,kBAAkB;AACrB;;AAEA;GACG,kBAAkB;GAClB,aAAa;AAChB;;AAEA;GACG,cAAc;GACd,eAAe;GACf,WAAW;AACd;;AAEA;GACG,WAAW;GACX,YAAY;GACZ,aAAa;GACb,YAAY;AACf;;AAEA;GACG,aAAa,EAAE,SAAS;GACxB,oBAAoB;GACpB,mBAAmB;GACnB,uBAAuB;AAC1B;;AAEA;GACG,oBAAoB;AACvB;;AAEA;GACG,mBAAmB;AACtB;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,aAAa;AAChB;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,eAAe;AAClB;;AAEA;GACG,WAAW;GACX,sBAAsB;GACtB,eAAe;GACf,kBAAkB;GAClB,aAAa;GACb,eAAe;AAClB;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,mBAAmB;AACtB;;AAEA;GACG,qBAAqB;GACrB,qBAAqB;AACxB;;AAEA;GACG,MAAM;GACN,OAAO;GACP,QAAQ;GACR,SAAS;GACT,kBAAkB;GAClB,cAAc;GACd,gBAAgB;GAChB,gBAAgB;AACnB;;AAEA;GACG,kBAAkB;AACrB;;AAEA;GACG,kBAAkB;AACrB","sourcesContent":[".preview-header {\n   background: #2ab4c0;\n   height: 60px;\n   padding: 0 15px 0 10px;\n}\n\n.tab-info {\n   height: 100%;\n   margin-left: -12px;\n   width: 318px;\n}\n\n.preview-header .back-button {\n   background: transparent;\n   border: none;\n   color: rgba(255, 255, 255, .7);\n   cursor: pointer;\n   outline: none;\n   width: 32px;\n   height: 32px;\n}\n\n.doc-title {\n   margin: 0 15px 0 5px;\n}\n\n.doc-title h1 {\n   color: #fff;\n   font-size: 16px;\n   font-weight: normal;\n   margin: 0;\n   padding: 0;\n   white-space: nowrap;\n   overflow: hidden;\n   text-overflow: ellipsis;\n}\n\n.doc-title-modified {\n   color: rgba(255, 255, 255, .7);\n   font-size: 12px;\n   margin-top: 3px;\n}\n\n.file-action {\n   justify-content: flex-end;\n}\n\n.file-action button + button {\n   margin-left: 1em;\n}\n\n.file-action button.mat-button, .file-action button.mat-raised-button {\n   line-height: 28px;\n   min-width: 80px;\n   padding: 0 12px;\n}\n\n\n.image-viewer {\n   overflow: auto;\n}\n\n.image-viewer img {\n   background: #fff;\n   max-width: 100%;\n}\n\n.image-viewer::ng-deep svg {\n   width: 100%;\n}\n\n.text-viewer {\n   overflow: auto;\n   padding: 1em;\n   white-space: pre-wrap;\n}\n\n.mail-viewer {\n   padding: 1em;\n}\n\n.mail-viewer table, .mail-viewer iframe, iframe {\n   border-collapse: collapse;\n   border: none;\n   width: 100%;\n   height: 100%;\n}\n\n.mail-viewer td:first-child {\n   padding: 3px 5px;\n   text-align: right;\n   width: 80px;\n}\n\n.mail-viewer td:last-child {\n   padding: 3px 5px;\n}\n\n.address::ng-deep b {\n   color: #222;\n   font-weight: normal;\n}\n\n.mail-viewer .body {\n   height: 100%;\n   width: 100%;\n   vertical-align: top;\n}\n\n.mail-viewer td.attachment {\n   padding: 3px;\n}\n\n.mail-viewer .attachment div {\n   display: inline-block;\n   margin-right: 1em;\n   line-height: 2;\n}\n\n.mail-viewer a {\n   color: #ba68c8;\n   cursor: pointer;\n}\n\n.mail-viewer td:first-child {\n   color: #222;\n}\n\n.mail-viewer td.text {\n   padding: 0;\n}\n\n.mail-viewer td.html {\n   padding: 10px 0 0;\n}\n\n.mail-viewer .subject, .mail-viewer .fit {\n   background: #fff;\n   border: 1px solid #ececec;\n   border-radius: 3px;\n   box-shadow: inset 0 0 6px rgba(0, 0, 0, .05);\n   padding: 3px 5px;\n   white-space: pre-wrap;\n}\n\n.body iframe {\n   border: 1px solid #f4f5f7;\n   border-radius: 3px;\n}\n\n.mail-viewer .fit {\n   height: 100%;\n   overflow: auto;\n   padding: .5em 1em;\n}\n\naudio {\n   min-width: 80%;\n   visibility: hidden;\n}\n\n.video-viewer {\n   background-color: black;\n}\n\nvideo {\n   max-width: 100%;\n   max-height: 100%;\n   visibility: hidden;\n}\n\n.visible {\n   visibility: visible;\n}\n\n.can-not-preview {\n   padding: 2em;\n   text-align: center;\n}\n\n.preview-icon {\n   opacity: .7;\n   width: 160px;\n   height: 160px;\n   margin: auto;\n}\n\n.preview-error {\n   color: #1b2733;\n   font-size: 18px;\n   margin: 8px;\n}\n\n.preview-error-info {\n   color: #637282;\n}\n\n.preview-error-info span {\n   margin: 0 8px;\n}\n\n.can-not-preview button {\n   margin: 8px;\n}\n\n\n.info {\n   background: #fff;\n   width: 320px;\n   min-width: 320px;\n   overflow-y: auto;\n   transition: margin-right .2s;\n}\n\n.section-header {\n   border-bottom: 1px solid #eaeaea;\n   color: #222;\n   padding-bottom: 10px;\n   margin: 30px 0 10px;\n}\n\n.info .properties {\n   font-size: 13px;\n   line-height: 16px;\n   margin: 0;\n   padding: 0;\n}\n\n.info .edit {\n   color: #2ab4c0;\n   cursor: pointer;\n   font-size: 13px;\n   font-weight: 300;\n}\n\n.info label,\n.info dl dt {\n   color: #777;\n   display: block;\n   margin: 20px 0 0;\n   padding-bottom: 3px;\n}\n\n.info dl dd {\n   color: #444;\n   margin: 0 0 20px;\n   word-break: break-all;\n}\n\n.info input,\n.info textarea {\n   border: 1px solid #e5e5e5;\n   border-radius: 2px;\n   font-size: 13px;\n   outline: none;\n   padding: 3px 6px;\n   resize: none;\n   width: 100%;\n}\n\n.select-types {\n   padding-bottom: 10px;\n   margin: 30px 0 10px;\n   width: 100%;\n}\n\n.save-metadata {\n   margin-top: 20px;\n   text-align: right;\n}\n\n.save-button {\n   line-height: 1.7;\n   min-width: inherit;\n   padding: 0 1em;\n}\n\n\nmat-tab-group {\n   width: 100%;\n}\n\n.info::ng-deep .mat-tab-label {\n   height: auto;\n   line-height: 36px;\n   min-width: inherit;\n   padding: 0 1em;\n}\n\n.info::ng-deep .mat-tab-body-wrapper {\n   flex: 1;\n   margin-left: -5px;\n}\n\n.info::ng-deep .mat-tab-body-content {\n   display: flex;\n   flex-direction: column;\n   padding: 0 1em;\n   margin-right: -15px;\n   margin-left: 5px;\n}\n\n.example-header-image {\n   background-image: url('../../../../assets/images/profile.png');\n   background-size: cover;\n}\n\n.commentItem:hover .delComment {\n   display: block;\n}\n\n.delComment {\n   display: none;\n}\n\n.comments-container {\n   overflow-y: auto;\n}\n\n.no-comment {\n   padding: 1em;\n}\n\n.comments-container ul {\n   list-style: none;\n   margin: 0;\n   padding: 0;\n}\n\n.comments-container li {\n   margin-top: 1em;\n}\n\n.comment-item {\n   line-height: 20px;\n   margin-left: 48px;\n   position: relative;\n}\n\n.comment-item a {\n   cursor: pointer;\n}\n\n.btn-comment {\n   position: absolute;\n   top: 0;\n   right: 0;\n}\n\n.comment-item .avatar {\n   float: left;\n   margin-left: -48px;\n   margin-top: 3px;\n   width: 36px;\n   height: 36px;\n   border-radius: 50%;\n}\n\n.comment-item .time {\n   color: #657786;\n   font-size: 12px;\n}\n\n.comment-item .time:before {\n   content: \"\\00b7\";\n   padding: 0 5px;\n}\n\n.comment-item .delete {\n   color: #999;\n   cursor: pointer;\n   position: absolute;\n   top: 0;\n   right: 0;\n   font-size: 20px;\n   width: 20px;\n   height: 20px;\n   display: none;\n}\n\n.comment-item:hover .delete {\n   display: block;\n}\n\n.comment-item .delete:hover {\n   color: #d32f2f;\n}\n\n.add-comment {\n   text-align: right;\n   margin-bottom: 10px;\n}\n\n.add-comment textarea {\n   display: block;\n}\n\n.add-comment button {\n   margin-top: .5em;\n   padding: 1px 16px;\n   line-height: initial;\n   min-width: 64px;\n}\n\n.relative {\n   position: relative;\n}\n\n.page-notfound {\n   text-align: center;\n   padding: 10em;\n}\n\n.page-notfound-error {\n   color: #1b2733;\n   font-size: 30px;\n   margin: 8px;\n}\n\n.page-notfound-icon {\n   opacity: .7;\n   width: 200px;\n   height: 200px;\n   margin: auto;\n}\n\n.img-center {\n   display: flex; /*for IE*/\n   display: -webkit-box;\n   align-items: center;\n   justify-content: center;\n}\n\n.slide-right {\n   margin-right: -320px;\n}\n\n.slide-left {\n   margin-left: -100px;\n}\n\n.blur {\n   filter: blur(4px);\n}\n\n.editing .item-content, .textarea-content {\n   display: none;\n}\n\n.editing .textarea-content {\n   display: block;\n}\n\n.textarea-content {\n   margin-top: 5px;\n}\n\n.edit2, .delete2 {\n   color: #999;\n   vertical-align: middle;\n   font-size: 16px;\n   text-align: center;\n   display: none;\n   cursor: pointer;\n}\n\n.edit2:hover, .delete2:hover {\n   color: #d32f2f;\n}\n\n.comment-item:hover .delete2, .comment-item:hover .edit2 {\n   display: table-cell;\n}\n\n.word-break {\n   word-break: break-all;\n   white-space: pre-line;\n}\n\n::ng-deep .mat-tab-body {\n   top: 0;\n   left: 0;\n   right: 0;\n   bottom: 0;\n   position: absolute;\n   display: block;\n   overflow: hidden;\n   flex-basis: 100%;\n}\n\n.set-scroll-hide {\n   overflow-y: hidden;\n}\n\n.set-scroll {\n   overflow-y: scroll;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
